import React, { useState } from 'react';
import { updateCurrencyRates } from '../../../../api/settingsApi';
import MobileProductDialog from './MobileProductDialog';
import MobileProductField from './MobileProductField';
import MobileProductFeedback from './MobileProductFeedback';
import useMobileMutation from './useMobileMutation';
import { readNumber } from './mobileProductUtils';

export default function MobileCurrencyRates({ rates, error, onRetry, onSaved, onClose }) {
  const [draft, setDraft] = useState(rates);
  const mutation = useMobileMutation();
  const save = () => {
    if (['pound_rate', 'dollar_rate', 'euro_rate'].some(key => !(readNumber(draft[key]) > 0))) {
      mutation.setError('Усі курси мають бути більшими за нуль');
      return;
    }
    mutation.run(
      () =>
        updateCurrencyRates(
          readNumber(draft.pound_rate),
          readNumber(draft.dollar_rate),
          readNumber(draft.euro_rate),
        ),
      () => {
        onSaved('Курси валют оновлено');
        onClose();
      },
    );
  };
  return (
    <MobileProductDialog
      size='compact'
      title='Курси валют'
      busy={mutation.busy}
      onClose={onClose}
      onSubmit={save}
      footer={
        <>
          <button
            type='button'
            className='btn btn-outline-secondary'
            disabled={mutation.busy}
            onClick={onClose}
          >
            Скасувати
          </button>
          <button type='submit' className='btn btn-dark' disabled={mutation.busy}>
            Зберегти
          </button>
        </>
      }
    >
      <MobileProductFeedback error={mutation.error || error} onRetry={error && onRetry} />
      <fieldset disabled={mutation.busy}>
        {[
          ['pound_rate', 'Фунт, грн за £1'],
          ['dollar_rate', 'Долар, грн за $1'],
          ['euro_rate', 'Євро, грн за €1'],
        ].map(([key, label]) => (
          <MobileProductField
            key={key}
            label={label}
            inputMode='decimal'
            value={draft[key]}
            onChange={value => setDraft(prev => ({ ...prev, [key]: value }))}
          />
        ))}
      </fieldset>
    </MobileProductDialog>
  );
}
